import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=748a363d&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('748a363d')) {
      api.createRecord('748a363d', component.options)
    } else {
      api.reload('748a363d', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=748a363d&", function () {
      api.rerender('748a363d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22eYVouS6rb90/JS/comp/childrenage.vue"
export default component.exports